(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-shop-the-look"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  var wrappers = document.querySelectorAll('.rb-cards');

  wrappers.forEach(function(wrapper){

    let isDown = false;
    let startX;
    let scrollLeft;

    wrapper.addEventListener('mousedown', function(e){
      isDown = true;
      wrapper.classList.add('dragging');
      startX = e.pageX - wrapper.offsetLeft;
      scrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('mouseleave', function(){
      isDown = false;
      wrapper.classList.remove('dragging');
    });

    wrapper.addEventListener('mouseup', function(){
      isDown = false;
      wrapper.classList.remove('dragging');
    });

    wrapper.addEventListener('mousemove', function(e){
      if(!isDown) return;
      e.preventDefault();
      const x = e.pageX - wrapper.offsetLeft;
      const walk = (x - startX) * 2;
      wrapper.scrollLeft = scrollLeft - walk;
    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
